import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '机智鸟 - AI财税+超企服平台，让企业致胜AI时代' },
    component: Home,
    // meta:{title:'创业小鸟-让天下没有难创的业'}
  },
  {
    path: '/product/tax',
    name: 'Product',
    meta: { title: '机智鸟AI记账报税系统 - 机智鸟' },
    component: () => import('@/views/product'),
  },
  {
    path: '/product',
    name: 'Tax',
    meta: { title: '机智鸟AI记账报税系统 - 机智鸟' },
    redirect: '/product/tax'
  },
  {
    path: '/product/manage',
    name: 'Manage',
    meta: { title: '机智鸟BOSS管理系统 - 机智鸟' },
    component: () => import('@/views/product/manage'),
  },
  {
    path: '/product/platform',
    name: 'Platform',
    meta: { title: '机智鸟超企服平台 - 机智鸟' },
    component: () => import('@/views/product/platform'),
  },
  {
    path: '/cooperate',
    name: 'Cooperate',
    meta: { title: '渠道合作 - 机智鸟' },
    component: () => import('@/views/cooperate'),
  },
  {
    path: '/news',
    name: 'News',
    meta: { title: '新闻资讯 - 机智鸟' },
    component: () => import('@/views/news'),
  },
  {
    path: '/news/detail',
    name: 'Newsdetail',
    meta: { title: '新闻资讯 - 机智鸟' },
    component: () => import('@/views/news/detail'),
  },
  {
    path: '/news/video',
    name: 'Video',
    meta: { title: '视频列表 - 机智鸟' },
    component: () => import('@/views/news/video'),
  },
  {
    path: '/about',
    name: 'About',
    meta: { title: '关于我们 - 机智鸟' },
    component: () => import('@/views/about'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }
})

export default router
